<template>
  <div v-if="info" class="reply-item">
    <FeedTool
      class="feed-tool"
      :operateUuid="info.replyerUserUuid"
      :masterUuid="masterUuid"
      @clickdelete="deleteReply"
    />
    <div class="reply-title">
      <span class="nickname">{{ info.replyerNickname }}</span>
      <template v-if="info.replyeeUserUuid">
        <span class="reply-line">{{$t('upgrade_page_views_master_components_skill_info_comment_info_279')}}</span>
        <span class="nickname">{{ info.replyeeNickname }}</span>
      </template>
      <span class="ninkname">：</span>
      <span>{{ info.content }}</span>
    </div>
    <div class="reply-time">
      <span>{{ timeToMin(info.createTime) }}</span>
      <button @click="toWriteReply">{{$t('upgrade_page_views_master_components_skill_info_comment_info_279')}}</button>
    </div>
    <div v-if="showWriteReply" class="write-reply-wrap">
      <div class="write-reply" @click="replyWriteFocus">
        <textarea v-model="replyText" ref="reply_write" class="reply-area" :maxlength="maxlength" rows="3" @click.stop />
        <span class="write-count">{{ replyText.length }}/{{ maxlength }}</span>
      </div>
      <div class="reply-btns">
        <button class="cancel-reply" @click="showWriteReply = false">{{$t('upgrade_page_layout_header_42')}}</button>
        <button class="confirm-reply" @click="submitReply">
          <i v-if="submitingReply" class="el-icon-loading"></i>
          <span v-else>{{$t('components_order_order_card_525')}}</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { writeMomentReply, deleteReply } from './moment'
import FeedTool from './feed-tool'
export default {
  components: {
    FeedTool,
  },
  props: {
    info: {
      type: Object,
      default: null,
    },
    masterUuid: String,
  },
  data() {
    return {
      showWriteReply: false,
      submitingReply: false,
      maxlength: 140,
      replyText: '',
    }
  },
  created() {

  },
  methods: {
    deleteReply() {
      if (this.deleting) return
      this.deleting = true
      const replyId = this.info.id
      this.$emit('deletereply', replyId)
      deleteReply({
        replyId,
      }).then(() => {
        this.deleting = false
      }).catch(() => {
        this.deleting = false
      })
    },
    submitReply() {
      const { replyText, info: { commentId, id: replyId } } = this
      if (this.submitingReply || !replyText) return
      this.submitingReply = true
      writeMomentReply({
        content: replyText,
        commentId,
        replyId,
      }).then(({ data }) => {
        this.submitingReply = false
        this.replyText = ''
        this.showWriteReply = false
        this.$message.success(i18n.t('components_order_order_card_564'))
        this.$emit('replycomment', data)
      }).catch(() => {
        this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1289'))
        this.submitingReply = false
      })
    },
    timeToMin(time) {
      const d = new Date(time)
      const now = Date.now()
      const createTime = d.getTime()
      // 距离现在几分钟
      let sub = Math.floor((now - createTime) / 60 / 1000)
      if (sub < 5) return i18n.t('upgrade_page_views_user_feed_feed_detail_1424')
      if (sub < 60) return sub + i18n.t('utils_util_1391')
      if (sub < 60 * 24) return Math.floor(sub / 60) + i18n.t('utils_util_1388')
      if (sub < 7 * 60 * 24) return Math.floor(sub / 60 / 24) + i18n.t('utils_util_1389')
      let month = d.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      let date = d.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return `${d.getFullYear()}-${month}-${date}`
    },
    toWriteReply() {
      if (!this.$store.state.app.userInfo) {
        this.$util.Login().then(() => {
          this.toWriteReply()
        })
        return
      }
      this.showWriteReply = true
      this.$nextTick(() => {
        this.replyWriteFocus()
      })
    },
    replyWriteFocus() {
      const dom = this.$refs.reply_write
      if (dom) dom.focus()
    },
  }
}
</script>
<style lang="scss" scoped>
  .reply-item {
    position: relative;
    .feed-tool {
      position: absolute;
      top: 0;
      right: 0;
      opacity: 0;
    }
    &:hover .feed-tool {
      opacity: 1;
    }
    .reply-title {
      @include flex(flex-start);
      margin-right: 38px;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-2;
      .nickname {
        font-weight: 500;
      }
      .reply-line {
        color: $color-gray-3;
      }
    }
    .reply-time {
      font-size: 12px;
      line-height: 14px;
      color: $color-gray-3;
      margin-top: 4px;
    }
  }
  .write-reply {
    background: #F9F9F9;
    border: 1px solid $color-split;
    border-radius: 8px;
    padding: 12px 12px 10px;
    @include flex(flex-start, flex-end, column);
    .reply-area {
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      resize: none;
    }
    .write-count {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-4;
    }
  }
  .write-reply-wrap {
    margin-top: 37px;
    .reply-btns {
      margin-top: 8px;
      @include flex(flex-end);
      button {
        width: 80px;
        height: 32px;
        @include flex;
        font-size: 13px;
        line-height: 18px;
        border-radius: 50px;
      }
      .cancel-reply {
        color: $color-gray-2;
        border: 1px solid $color-split;
        margin-right: 10px;
      }
      .confirm-reply {
        color: $color-gray-1;
        background: $color-yellow;
      }
    }
  }
</style>
